// export const primary = {
//   100: "#D3F5FE",
//   200: "#A7E7FD",
//   300: "#7AD2FA",
//   400: "#59BCF5",
//   500: "#2499EF",
//   main: "#2499EF",
//   light: "#D3F5FE",
//   dark: "#1A77CD",
//   red: "#FF6B93",
//   purple: "#A798FF",
//   yellow: "#FF9777",
// };

// export const secondary = {
//   100: "#F9F9F9",
//   200: "#ECEFF5",
//   300: "#E5EAF2", // outline or border
//   400: "#546890", // text muted
//   500: "#1d2438", // main text
//   main: "#1d2438", // main text
//   light: "#F9F9F9",
//   red: "#FF6B93",
//   purple: "#A798FF",
//   yellow: "#FF9777",
// };

export const primary = {
  100: "#f9f9ff",
  200: "#ebebff",
  300: "#9A86A4",
  400: "#827397",
  500: "#4D4C7D",
  main: "#363062",
  light: "#D3F5FE",
  dark: "#1c1649",
  red: "#FF6B93",
  purple: "#A798FF",
  yellow: "#FF9777",
  link: "#3468fd",
};

export const secondary = {
  100: "#F9F9F9",
  200: "#ECEFF5",
  300: "#E5EAF2", // outline or border
  400: "#546890", // text muted
  500: "#1d2438", // main text
  main: "#1d2438", // main text
  title: "#44435d",
  light: "#F9F9F9",
  red: "#FF6B93",
  purple: "#A798FF",
  yellow: "#FF9777",
};

export const error = {
  main: "#FD396D",
};

export const success = {
  main: "#2CC5BD",
};

export const warning = {
  main: "#FFE91F",
  dark: "#FFD600",
};

export const info = {
  main: "#A798FF",
};

export const text = {
  primary: secondary[500],
  secondary: secondary[400],
  disabled: secondary[300],
  link: primary.link,
};
